import { useParams } from 'react-router-dom';
import { useBookings } from '../../shared/booking/BookingsContext';
import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { formatPrice } from '../../shared/data/common';
import { hotelRefund, penaltyLines } from './data';
import HotelSummary from './HotelSummary';
import HotelStay from './HotelStay';

export default function HotelBookingDetails() {
  const { bookingId } = useParams();
  const { getBooking } = useBookings();
  const booking = getBooking(bookingId);
  // Live bookings are cancelled with the hotel from the stay panel.
  const live = Boolean(booking?.supplierBookingId);

  return (
    <BookingDetailsPage
      module="hotels"
      Summary={HotelSummary}
      refLabel="Hotel confirmation no."
      refund={hotelRefund}
      allowCancel={!live}
      extraDetails={live && <HotelStay booking={booking} allowCancel={booking.status !== 'cancelled'} />}
      policy={live ? [
        ...penaltyLines(booking.summary.cancellation, formatPrice),
        'Refunds go to your original payment method within 5–7 working days; the convenience fee is not refunded.',
        'No-shows are charged the full booking amount.',
      ] : [
        'Free cancellation rates: full refund if cancelled at least 24 hours before check-in.',
        'Non-refundable rates and late cancellations: the first night is charged.',
        'No-shows are charged the full booking amount.',
        'Refunds are credited to the original payment method within 5–7 working days.',
      ]}
    />
  );
}
